import React, {
  useContext,
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from 'react'
import {
  strCol,
  intCol,
  dateTimeCol,
  numCol,
} from '@integec/grid-tools/lib/cols'
import {
  modifierCol,
  modifiedDateCol,
  utilityReqHeader,
  unitHeader,
} from 'core/HeaderColTypeProps'
import { getApiTargetInfo, UnitSelection, ExportComponent } from 'core'
import { connect } from 'react-redux'
import R from 'ramda'
import {
  // getCard97,
  // deleteCard97,
  getSystemConfigurationInfo,
  pjmEventPending,
  pjmEventPendingApprove,
  // getCard97ExtensionSpec,
  // getCauseCodeAll,
} from 'api/pgads'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getUtilityUnitsMap,
  getCauseCodeMap,
  getUnits,
  getFailCode,
  getAmlificationCode,
  getPermitActions,
  getEnvConfig,
  getEventTypes,
  getCauseCodeOmcMap,
} from 'core/selectors'
import { Button, Input, Empty, message, DatePicker } from 'antd'
import {
  UnitSelectionContext,
  SpinContext,
  ErrorContext,
  DatePickerContext,
  JcTmpErrorContext,
} from 'context'
import {
  CriteriaRow,
  Title,
  Content,
  FullHeightSizer,
  Filler,
} from 'core/screen-util'
import Grid, { virtualizedGridRenderer } from '@integec/grid-tools'
import {
  rowHeaderRender,
  hasAccesPermits,
  exportDataComponent,
} from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import {
  BROOKFIELD_CLIENT,
  CALPLINE_CLIENT,
  CPS_CLIENT,
  WEE_CLIENT,
} from 'client'
// import DomNucExtension from './component/card97/DukeNucExtension'
import { card97TableCellRender } from 'card-data/Card97Antd'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'

export const headers = [
  unitHeader,
  intCol({ ident: 'year', display: 'Year', isKey: true, width: 50 }),
  intCol({
    ident: 'eventNum',
    display: 'Event Number',
    isKey: true,
    width: 60,
  }),
  // intCol({ ident: 'eventIdx', display: 'Event Index', isKey: true, width: 60 }),
  strCol({
    ident: 'eventType',
    display: 'Event Type',
    isKey: true,
    isFiltered: true,
    width: 60,
  }),
  utilityReqHeader,
  dateTimeCol({
    ident: 'eventStart',
    display: 'Event Start Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'eventEnd',
    display: 'Event End Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  strCol({ ident: 'availCap', display: 'Available Capacity' }),
  intCol({ ident: 'causeCode', display: 'Cause Code', isFiltered: true }),
  strCol({ ident: 'conCode', display: 'Contribution Code' }),
  strCol({ ident: 'ioCode', display: 'Dominant' }),
  dateTimeCol({
    ident: 'workStart',
    display: 'Work Start Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  dateTimeCol({
    ident: 'workEnd',
    display: 'Work End Date',
    width: 150,
    displayFormat: 'MM/DD/YYYY HH:mm',
  }),
  intCol({ ident: 'manHour', display: 'Man Hours' }),
  strCol({ ident: 'failCode', display: 'Fail Code', isFiltered: true }),
  strCol({ ident: 'ampCode', display: 'Amplification Code', isFiltered: true }),
  strCol({
    ident: 'description',
    display: 'Description',
    width: 2000,
    alignment: 'left',
  }),

  modifierCol,
  modifiedDateCol,
  // strCol({ ident: 'lock', display: 'Lock' }),
].map(e => ({ ...e, isFiltered: true }))

export const timeZoneList = R.compose(
  R.fromPairs,
  R.map(a => [`${a.utility}${a.unit}`, a.timeZone])
)
export const unitCodeList = R.compose(
  R.fromPairs,
  R.map(a => [`${a.utility}${a.unit}`, a.id1])
)
export const unitShortNameList = R.compose(
  R.fromPairs,
  R.map(a => [`${a.utility}${a.unit}`, a.shortName])
)
// const ampCodeList = R.compose(
//   R.fromPairs,
//   R.map(a => [a.ampCode, `[${a.ampCode}]${a.description}`])
// )
// const failCodeList = R.compose(
//   R.fromPairs,
//   R.map(a => [a.code, `[${a.code}]${a.description}`])
// )

const title = 'Event Pending Approval'

const EventPendingApproval = ({
  utilityNameMap,
  unitNameMap,
  apiTargetInfo,
  actionPermits,
  envConfig,
  units,
  causeCodeOmcMap,
}) => {
  const CLIENT = envConfig.clientId || 'INTEG'
  const { setSpinning } = useContext(SpinContext)
  const { setTmpError } = useContext(JcTmpErrorContext)
  const { setError } = useContext(ErrorContext)
  const [data, setData] = useState(null)

  //  const [err, setError] = useState(null)
  const [selectedRows, setSelectedRows] = useState([])

  const [card97Dominant, setCard97Dominant] = useState(false)

  // const [unitsList, setUnitList] = useState([])

  // const [ampCodeMap, setAmpCodeMap] = useState({})
  // const [failCodeMap, setFailCodeMap] = useState({})
  const { selectedUnits, setVisibleUnitSelection } = useContext(
    UnitSelectionContext
  )
  const { selectedDate, setSelectedDate } = useContext(DatePickerContext)

  // const [causeCodeList, setCauseCodeList] = useState([])
  // useEffect(
  //   _ => {
  //     getCauseCodeAll(apiTargetInfo).fork(setError, setCauseCodeList)
  //   },
  //   [apiTargetInfo, setError]
  // )

  const setErr = useCallback(
    err => {
      setError(err)
      setSpinning(false)
      setData(null)
    },
    [setError, setSpinning]
  )

  const selectionChange = ({ selectedRows }) => {
    setSelectedRows(selectedRows)
  }
  useEffect(
    _ => {
      getSystemConfigurationInfo(apiTargetInfo).fork(setErr, d => {
        const dominantData = d.filter(
          s => s.key === 'DOMINANT_DERATE' && s.value === 'YES'
        )
        // setState({ card97Dominant: dominantData.length > 0 ? true : false, loading: false })
        setCard97Dominant(dominantData.length > 0)
      })
    },
    [apiTargetInfo, setErr, units]
  )

  const onRetrieveData = ({ selUnits = selectedUnits }) => {
    if (selUnits.length <= 0) {
      setVisibleUnitSelection(true)
      message.error('Please,Select Unit')
      return
    }
    setSpinning(true)
    pjmEventPending(apiTargetInfo)({
      unitIds: selUnits.map(u => u.unitId),
      month: selectedDate.format('MM'),
      year: selectedDate.format('YYYY'),
    }).fork(setError, data => {
      setSpinning(false)
      setData(data)
      if (GridRef.current) GridRef.current.setSelectedRect({})
      setSelectedRows([])
    })
  }

  const [fuzzyFilter, setFuzzyFilter] = useState('')
  const eventApproval = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.VALIDATION_EVENT_PENDING_APPROVAL],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  // if required change bellow then also change in eventdashboard
  const clientHeaders = useMemo(
    _ => {
      if (
        CLIENT === WEE_CLIENT ||
        CLIENT === CPS_CLIENT ||
        CLIENT === CALPLINE_CLIENT
      ) {
        const WEline = numCol({
          ident: 'line',
          display: 'Duration (HRS)',
        })

        return R.insert(8, WEline, headers)
      } else if (CLIENT === BROOKFIELD_CLIENT) {
        const BKFline = numCol({
          ident: 'line',
          display: 'Spill MHH',
        })

        return R.insert(9, BKFline, headers)
      }
      return headers
    },
    [CLIENT]
  )

  const filterHeaders = useMemo(
    _ =>
      card97Dominant
        ? clientHeaders
        : clientHeaders.filter(h => !(h.ident === 'ioCode')),
    [card97Dominant, clientHeaders]
  )

  const headerWithFormatter = useMemo(
    _ =>
      filterHeaders.map(header =>
        header.ident === 'utility'
          ? {
              ...header,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) => utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : header.ident === 'unit'
          ? {
              ...header,
              // choices: [],
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unit] || rowData.unit,
            }
          : header
      ),
    [filterHeaders, unitNameMap, utilityNameMap]
  )

  const GridRef = useRef()

  const approveEvents = _ => {
    if (selectedRows.length <= 0) {
      message.warning('Pleae,Select Row(s)')
      return
    }
    setSpinning(true)
    const tempcard97 = selectedRows.map(
      ({ utility, unit, year, eventNum }) => ({
        utility,
        unit: unit.substr(3),
        year,
        eventNum,
      })
    )
    pjmEventPendingApprove(apiTargetInfo)(tempcard97).fork(
      setError,
      tmpError => {
        setSpinning(false)
        setTmpError(tmpError)
        if (!isErrorContains(tmpError)) {
          onRetrieveData({})
          setSelectedRows([])
        }
      }
    )
  }

  return [
    <>
      <div
        style={{
          backgroundColor: '#f0f2f5',
          marginLeft: '20px',
          marginRight: '20px',
        }}
      >
        <UnitSelection
          setData={() => {
            setData(null)
          }}
          accesskey="u"
          // retrieveData={onRetrieveData}
          // renderContent={renderUnitContent}
          retrieveData={onRetrieveData}
        />
        <CriteriaRow style={{}}>
          <Title
            style={{
              marginRight: '15px',
              marginBottom: '5px',
              marginLeft: '10px',
              minWidth: '300px',
            }}
          >
            {title}
          </Title>

          <DatePicker.MonthPicker
            style={{ marginLeft: '20px' }}
            onChange={date => setSelectedDate(date)}
            placeholder="Select month"
            format="MMM-YYYY"
            // style={{ width: '100%' }}
            value={selectedDate}
          />

          {/* <Button onClick={e => setCauseCodeDialog(true)}>Cause Code</Button> */}
          <Button
            style={{ marginLeft: '20px' }}
            onClick={onRetrieveData}
            type="primary"
            icon="database"
          >
            Retrieve
          </Button>

          {eventApproval && (
            <Button
              type="danger"
              onClick={approveEvents}
              style={{ marginLeft: '20px' }}
            >
              Approve
            </Button>
          )}
          <Filler />
          <Input.Search
            placeholder="Filter"
            value={fuzzyFilter}
            style={{
              gridColumnEnd: 'span 1',
              width: '200px',
            }}
            onChange={e => setFuzzyFilter(e.target.value)}
          />
          <ExportComponent
            getData={_ => exportDataComponent(GridRef, data, fuzzyFilter)}
            data={data}
            headers={headerWithFormatter}
            fileName={title}
            btnStyle={{}}
            disabled={!!(data && data.length <= 0)}
          />
        </CriteriaRow>
        <FullHeightSizer heightOffset={300}>
          {({ height, width }) =>
            data && data.length > 0 ? (
              <Content style={{ height: height - 20 }}>
                <Grid
                  ref={GridRef}
                  sortEnabled
                  data={data}
                  headers={headerWithFormatter}
                  altBy={u => u.unitId + u.eventNum}
                  altBgColor="#ebebeb"
                  // onEditInfoChange={info => editRow(info)}
                  // editInfo={editInfo}
                  render={virtualizedGridRenderer({
                    autoFixColByKey: false,
                    rowHeaderRender,
                    height: height - 60,
                    width: width - 50,
                    cellRender: card97TableCellRender({
                      causeCodeOmcMap,
                      CLIENT,
                    }),
                  })}
                  fuzzyFilter={fuzzyFilter}
                  isEditable={false}
                  onSelectionChange={rows => {
                    selectionChange(rows)
                  }}
                  selectionMode="single"
                  selectionType="row"
                  initialSortOptions={[
                    utilityReqHeader,
                    unitHeader,
                    { ident: 'year', sortOrder: 'asc' },
                    { ident: 'eventStart', sortOrder: 'asc' },
                    { ident: 'eventEnd', sortOrder: 'asc' },
                    // { ident: 'year', sortOrder: 'asc' },
                    { ident: 'eventNum', sortOrder: 'asc' },
                    // { ident: 'eventIdx', sortOrder: 'asc' },
                  ]}
                />
              </Content>
            ) : (
              <Content style={{ height: '200px' }}>
                <Empty
                  imageStyle={{ paddingTop: '30px' }}
                  description={
                    selectedUnits && selectedUnits.length <= 0
                      ? 'Please select units'
                      : data && data.length <= 0
                      ? 'No Data from Retrieve'
                      : 'Please click on retrieve button to retrieve data'
                  }
                />
              </Content>
            )
          }
        </FullHeightSizer>
      </div>
    </>,
  ]
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
  causeCodeMap: getCauseCodeMap(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  units: getUnits(state),
  ampCodeMap: getAmlificationCode(state),
  failCodeMap: getFailCode(state),
  eventTypesData: getEventTypes(state),
  causeCodeOmcMap: getCauseCodeOmcMap(state),
})
export default connect(mapStateToProps)(EventPendingApproval)
